import type { ResearchResultType } from '@/features/common/types/ResearchResultType';
import type { PublicCatalogKey } from '@/i18n/dictionaries/publicCatalog';

/**
 * The line a result card prints under its title, naming its kind — on a project's page and on its
 * institution's. A map rather than `resultType${type}` built at runtime, so a kind with no label
 * is a compile error instead of its key printed on the card.
 */
export const RESULT_TYPE_KEY: Record<ResearchResultType, PublicCatalogKey> = {
  PUBLICATION: 'resultTypePUBLICATION',
  PATENT: 'resultTypePATENT',
  TECHNOLOGY: 'resultTypeTECHNOLOGY',
  TRANSFER_ACTIVITY: 'resultTypeTRANSFER_ACTIVITY',
};
